var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 19.53L21.7 1.837a1.788 1.788 0 012.462-.565 1.78 1.78 0 01.566 2.455L12.534 23.163a1.788 1.788 0 01-2.667.415L.632 15.781a1.779 1.779 0 01-.21-2.511 1.788 1.788 0 012.517-.21l7.662 6.47z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconCheckmark;